import { render, staticRenderFns } from "./UnstakeModal.vue?vue&type=template&id=ffcc1f12&scoped=true"
import script from "./UnstakeModal.vue?vue&type=script&lang=js"
export * from "./UnstakeModal.vue?vue&type=script&lang=js"
import style0 from "./UnstakeModal.vue?vue&type=style&index=0&id=ffcc1f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcc1f12",
  null
  
)

export default component.exports